import reducer from "./reducer";
export { default as GeographicalStructure } from "./components/index";
export { default as geographicalStructureReducerName } from "./constants";
export default reducer;
